/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Fragment } from 'react';

import { Divider, Typography2 } from '@coursera/cds-core';
import { track } from '@coursera/event-pulse/sdk';

import MobileButton from 'bundles/composable-page-header/components/mobile-menu-items/MobileButton';
import { MOBILE_MAIN_IDENTIFIER } from 'bundles/composable-page-header/constants';
import { useMobileToSubPage } from 'bundles/composable-page-header/contexts/MobileNavigationContext';
import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';

import _t from 'i18n!nls/composable-page-header';

const styles = {
  exploreButton: css`
    margin-top: var(--cds-spacing-100);
  `,
};
const getButtons = () => [
  {
    label: _t('Explore roles'),
    id: MOBILE_MAIN_IDENTIFIER.EXPLORE_ROLES_MENU,
  },
  {
    label: _t('Explore categories'),
    id: MOBILE_MAIN_IDENTIFIER.EXPLORE_CATEGORIES_MENU,
  },
  {
    label: _t('Trending skills'),
    id: MOBILE_MAIN_IDENTIFIER.EXPLORE_SKILLS_MENU,
  },
  {
    label: _t('Earn a professional certificate'),
    id: MOBILE_MAIN_IDENTIFIER.EARN_PROFESSIONAL_CERTIFICATE_MENU,
  },
  {
    label: _t('Earn an online degree'),
    id: MOBILE_MAIN_IDENTIFIER.EARN_ONLINE_DEGREE_MENU,
  },
];

const ExploreMenuItem = () => {
  const toSubPage = useMobileToSubPage();

  if (GrowthDiscoveryExperiments.preview('simplifiedMegamenuQ12025') !== 'control') {
    return (
      <Fragment>
        {getButtons().map(({ id, label }, index) => (
          <MobileButton
            key={id}
            css={index === 0 ? styles.exploreButton : undefined}
            label={label}
            name={id}
            ariaLabel={label}
            trackingName={id}
            onButtonClick={() => {
              track('view_megamenu_items', {
                megamenuItemName: id,
                megamenuSection: id,
              });
              toSubPage?.(id);
            }}
          />
        ))}
        {GrowthDiscoveryExperiments.preview('simplifiedMegamenuQ12025') === 'B' && (
          <Fragment>
            <div css={{ marginTop: 'var(--cds-spacing-50)' }}>
              <Divider color="light" />
            </div>
            <Typography2
              component="p"
              variant="bodyPrimary"
              color="supportText"
              css={{
                padding: 'var(--cds-spacing-150) var(--cds-spacing-100) var(--cds-spacing-50)',
              }}
            >
              {_t('Not sure where to begin?')}
            </Typography2>
            <MobileButton
              label={_t('Browse free courses')}
              href="/courses?query=free"
              name="browseFreeCourses"
              trackingName="browse_free_courses"
              onButtonClick={() => {
                track('click_megamenu_item', {
                  megamenuItemLink: '/courses?query=free',
                  megamenuItemName: 'browse-free-courses',
                  megamenuSection: 'mobile',
                  megamenuItemType: 'other',
                });
              }}
            />
          </Fragment>
        )}
      </Fragment>
    );
  }

  return (
    <MobileButton
      css={styles.exploreButton}
      label={_t('Explore')}
      name="explore"
      ariaLabel={_t('Explore all catalog')}
      trackingName="mobile_header_explore_button"
      onButtonClick={() => {
        track('open_navigation_menu', {
          navigationType: 'megamenu',
        });
        toSubPage?.(MOBILE_MAIN_IDENTIFIER.EXPLORE_MENU);
      }}
    />
  );
};

export default ExploreMenuItem;
